// extracted by mini-css-extract-plugin
export default {"categoryText":"styles_categoryText__54mOw"};